import methods from '@/services/methods'

export default {
  liveEvents () {
    return methods.sendGet(`service_status`, null, {noHyptoLoader: true})
  },
  pastEvents (payload) {
    return methods.sendGet(`service_status/past_events`, payload, {noHyptoLoader: true})
  },
  upcomingEvents (payload) {
    return methods.sendGet(`service_status/upcoming_events`, payload, {noHyptoLoader: true})
  },
  beneBankStatus () {
    return methods.sendGet(`service_status/beneficiary_banks_status`, null, {noHyptoLoader: true})
  },
  beneBankEvents (payload) {
    return methods.sendGet(`service_status/beneficiary_banks_events`, payload, {noHyptoLoader: true})
  }
}
